import moment from "moment";
import React, { Component } from "react"
import { Datos_Empresa, development } from "../../../libs/utils/Const";

const formatNumber = (num = "") => {
    const separador = ","; // separador para los miles
    const sepDecimal = "."; // separador para los decimales

    let splitStr = num.split(".");
    let splitLeft = splitStr[0];
    let splitRight = splitStr.length > 1 ? sepDecimal + splitStr[1] : "";
    let regex = /(\d+)(\d{3})/;

    while (regex.test(splitLeft)) { splitLeft = splitLeft.replace(regex, "$1" + separador + "$2"); }
    return splitLeft + splitRight;
};

const formatType = (type = "") => {
    switch (type) {
        case "A": return "Conjunto";
        case "P": return "Producción";
        case "S": return "Ventas";
        case "T": return "Modelo";
        default: return "";
    }
}

const finalDocStyles = {
    fontSize: { fontSize: 12 },

    colNormal: { whiteSpace: "wrap" },
    colNumber: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "right" },
}

const previewStyles = {
    colNormal: { whiteSpace: "wrap" },
    colNumber: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "right" },
}

class ProductionTreeReport extends Component {
    render() {
        const { DocsToPrint, ReportsModel, finalDoc } = this.props;
        const styles = finalDoc ? finalDocStyles : previewStyles;

        const ProductionTrees = DocsToPrint[0].ProductionTrees;

        return (
            <div className="p-4">
                <div className="row text-center">
                    <div className="col-3 align-content-center" style={styles.fontSize}>
                        <img src={development ? require("../../../images/logo_draft.svg") : require("../../../images/logo_EMPRESA.svg")} alt="Logo" />
                        {Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}
                    </div>
                    <div className="col-5 align-content-center">
                        <p className="font-weight-bold h5"> Lista de materiales </p>
                    </div>
                    <div className="col-4 text-right">
                        <p> {ReportsModel?.user?.Branch?.Address || `${Datos_Empresa.Calle} No. ${Datos_Empresa.Numero}, COL. ${Datos_Empresa.Colonia}, ${Datos_Empresa.Ciudad}, ${Datos_Empresa.Estado}. ${Datos_Empresa.Pais}`} al {moment().format("DD/MM/YYYY")}</p>
                        {ReportsModel.user && <p> Impreso por: {ReportsModel.user.USER_CODE} - {ReportsModel.user.U_NAME} </p> }
                    </div>
                </div>

                <div className="mt-4" style={styles.fontSize}>
                    <div className="border border-dark font-weight-bold">
                        <div className="row px-3">
                            <div className="col-5">
                                <div className="row">
                                    <div className="col-5" style={styles.colNormal}> Artícluo </div>
                                    <div className="col-7" style={styles.colNormal}> Descripción </div>
                                </div>
                            </div>

                            <div className="col-7">
                                <div className="row">
                                    <div className="col-2" style={styles.colNormal}> Tipo </div>
                                    <div className="col-2" style={styles.colNumber}> Cantidad </div>
                                    <div className="col-2" style={styles.colNumber}> Precio </div>
                                    <div className="col-2" style={styles.colNormal}> Unidad </div>
                                    <div className="col-2" style={styles.colNormal}> Linea </div>
                                    <div className="col-2" style={styles.colNormal}> Almacén </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="border border-dark">
                        {ProductionTrees.map((ProductionTree, index) =>
                            <>
                                <div className="row px-3">
                                    <div className={`col-5 ${index ? "border-top" : ""} border-dark py-2`}>
                                        <div className="row">
                                            <div className="col-5" style={styles.colNormal}> {ProductionTree.Code} </div>
                                            <div className="col-7" style={styles.colNormal}> {ProductionTree.ItemName} </div>
                                        </div>
                                    </div>
                                    <div className={`col-7 ${index ? "border-top" : ""} border-dark py-2`}>
                                        <div className="row">
                                            <div className="col-2" style={styles.colNormal}> {formatType(ProductionTree.TreeType)} </div>
                                            <div className="col-2" style={styles.colNumber}> {formatNumber(Number(ProductionTree.Qauntity).toFixed(3))} </div>
                                            <div className="col-2" style={styles.colNumber}> {formatNumber(Number(ProductionTree.Price).toFixed(2))} </div>
                                            <div className="col-2" style={styles.colNormal}> {ProductionTree.InvntryUom} </div>
                                            <div className="col-2" style={styles.colNormal}> {ProductionTree.ItmsGrpNam} </div>
                                            <div className="col-2" style={styles.colNormal}> {ProductionTree.ToWH} </div>
                                        </div>
                                    </div>
                                </div>

                                {Array.isArray(ProductionTree.Lines) ?
                                    ProductionTree.Lines.map(line =>
                                        <div className="row px-3">
                                            <div className="col-5 border-top py-2">
                                                <div className="row">
                                                    <div className="col-5" style={styles.colNormal}> {line.Code} </div>
                                                    <div className="col-7" style={styles.colNormal}> {line.ItemName} </div>
                                                </div>
                                            </div>
                                            <div className="col-7 border-top py-2">
                                                <div className="row">
                                                    <div className="col-2" style={styles.colNormal}> N </div>
                                                    <div className="col-2" style={styles.colNumber}> {formatNumber(Number(line.Quantity).toFixed(3))} </div>
                                                    <div className="col-2" style={styles.colNumber}> {formatNumber(Number(line.Price).toFixed(2))} </div>
                                                    <div className="col-2" style={styles.colNormal}> {line.Uom} </div>
                                                    <div className="col-2" style={styles.colNormal}> </div>
                                                    <div className="col-2" style={styles.colNormal}> {line.Warehouse} </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                    :
                                    <></>
                                }
                            </>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default ProductionTreeReport